import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { selectActiveGame, selectDeckPile, selectHand, selectPrizePile, selectUser } from '../ActiveGame/selectors';
import { PRIZE_POSITIONS } from '../Board/layout';
import { Bar, Name, Pip, Pips, Stat, TurnDot } from './styled';
import Anchor from '../Motion/Anchor';
import { anchors } from '../Motion/anchorNames';

/** A player's name and the counts that matter: prizes left, cards in hand, cards in deck. */
const PlayerBar = ({ userId, you }) => {
  const game = useSelector(selectActiveGame);
  const user = useSelector((state) => selectUser(state, { userId }));
  const deckPile = useSelector((state) => selectDeckPile(state, { userId }));
  const hand = useSelector((state) => selectHand(state, { userId }));
  const prizePile = useSelector((state) => selectPrizePile(state, { userId }));

  const prizesLeft = prizePile ? prizePile.get('cards').size : 0;
  const theirTurn = game.get('active_player_id') === userId && !game.get('ended_at');

  return (
    <Bar>
      {theirTurn && <TurnDot aria-label="Their turn" />}
      <Name>{you ? 'You' : user && user.get('name')}</Name>
      {prizePile && <Stat aria-label={`${prizesLeft} prizes left`}>
        Prizes <Pips>{PRIZE_POSITIONS.map(i => <Pip key={i} $taken={i >= prizesLeft} />)}</Pips>
      </Stat>}
      {/* The opponent's cards fly here when they draw or take a prize; yours fly into your hand itself. */}
      {hand && (you
        ? <Stat>Hand <b>{hand.get('count')}</b></Stat>
        : <Anchor name={anchors.hand(userId)}><Stat>Hand <b>{hand.get('count')}</b></Stat></Anchor>)}
      {deckPile && <Stat>Deck <b>{deckPile.get('count')}</b></Stat>}
    </Bar>
  );
};

PlayerBar.propTypes = {
  userId: PropTypes.number.isRequired,
  you: PropTypes.bool,
};

export default PlayerBar;
